export default __webpack_public_path__ + "static/media/logo2018BW.aba06d62.png";